import { useContext } from "react";
import { Box } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { UBButton, ParagraphText, HeadingText } from "../../../../Libraries";
import { LanguageContext } from "../../../../context/LanguageContext";
import { Limitincreaseprocess } from "../../../../assets/icons/icon";
import { analytics, triggerLogEvent } from "../../../../config/firebase";
import styles from "./LimitIncreaseInProcess.module.css";

const LimitIncreaseInProcess = () => {
  const [I18n] = useContext(LanguageContext);
  const navigate = useNavigate();

  return (
    <Box className={styles.page}>
      <Box className={styles.content}>
        <Limitincreaseprocess />
        <HeadingText
          className={`fontSize24 fontWeight500 ${styles.title}`}
        >
          {I18n.limit_increase_is_in_process}
        </HeadingText>
        <ParagraphText
          className={`fontSize14 newLightColor ${styles.subtitle}`}
        >
          {I18n.limit_increase_is_in_process_subtitle}
        </ParagraphText>
        <UBButton
          id="account_limit_go_home_btn"
          onClick={() => {
            triggerLogEvent(analytics, "w_acc_limit_go_home");
            navigate("/UCash");
          }}
          title={I18n.go_to_home}
          className={`ubPrimaryButton textUppercase ${styles.homeBtn}`}
        />
      </Box>
    </Box>
  );
};

export default LimitIncreaseInProcess;
